<!--
 * @Description: 房间显示
 * @Date: 2022-03-16 17:40:28
 * @LastEditTime: 2022-03-29 16:13:06
-->
<template>
  <div class="rtc-container">
    <!-- 进房操作区域 -->
    <div class="control-container">
      <div class="rtc-control-container">
        <el-button class="button" type="primary" size="small" :disabled="isJoining || isJoined"
          @click="handleJoinRoom">进入房间</el-button>
        <!-- {{homeInfo}} -->
        <!-- <el-button v-if="isHostMode" class="button" type="primary" size="small" :disabled="isPublishing || isPublished" @click="handlePublish">发布流</el-button>
        <el-button v-if="isHostMode" class="button" type="primary" size="small" @click="handleUnpublish">取消发布流</el-button>-->
        <el-button class="button" type="primary" size="small" @click="handleLeave">离开房间</el-button>
        <el-button class="button" type="primary" size="small" @click="sendmesg">发送短信</el-button>
      </div>
    </div>

    <!-- 显示邀请链接 -->
    <!-- <div v-if="showInviteLink" class="invite-link-container">
      <el-input class="invite-input" v-model="inviteLink">
        <template slot="prepend">
          <el-tooltip
            :visibleArrow="false"
            effect="dark"
            content="Copied!"
            placement="bottom"
            :manual="true"
            v-model="showCopiedTip"
          >
            <span class="invite-btn" @click="handleCopyInviteLink">
              <svg-icon icon-name="copy"></svg-icon>
            </span>
          </el-tooltip>
        </template>
</el-input>
</div>-->

    <div class="info-container">
      <!-- Log 展示区域 -->
      <!-- <div v-if="isHostMode" class="log-container" ref="logContainer"> -->
      <!-- <p class="log-label">Log:</p> -->
      <!-- <div v-for="(item, index) in logList" :key="index">
          <span class="log-state" v-if="item.type === 'success'">🟩</span>
          <span class="log-state" v-if="item.type === 'failed'">🟥</span>
          <span>{{ item.log }}</span>
      </div>-->
      <!-- </div> -->
      <!-- 本地流区域 -->
      <div v-if="localStream" class="local-stream-container">
        <!-- 本地流播放区域 -->
        <div id="localStream" class="local-stream-content"></div>
        <!-- 本地流操作栏 -->
        <div v-if="isPlayingLocalStream" class="local-stream-control">
          <div class="video-control control">
            <span v-if="!isMutedVideo" @click="muteVideo">
              <i class="el-icon-camera" style="color:white"></i>
              <!-- <svg-icon icon-name="video" class="icon-class"></svg-icon> -->
            </span>
            <span v-if="isMutedVideo" @click="unmuteVideo">
              <i class="el-icon-camera-solid"></i>
              <!-- <svg-icon icon-name="video-muted" class="icon-class"></svg-icon> -->
            </span>
          </div>
          <div class="audio-control control">
            <span v-if="!isMutedAudio" @click="muteAudio">
              <i class="el-icon-microphone" style="color:white"></i>
              <!-- <svg-icon icon-name="audio" class="icon-class"></svg-icon> -->
            </span>
            <span v-if="isMutedAudio" @click="unmuteAudio">
              <i class="el-icon-turn-off-microphone" style="color:white"></i>
              <!-- <svg-icon icon-name="audio-muted" class="icon-class"></svg-icon> -->
            </span>
          </div>
        </div>
      </div>
      <!-- 远端流区域 -->
      <div class="remote-container">
        <div v-for="(item) in remoteStreamList" :key="item.getUserId()" :id="item.getUserId()"
          class="remote-stream-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import rtc from "./mixins/rtc.js";
import shareRtc from "./mixins/share-rtc.js";
import LibGenerateTestUserSig from "@/utils/lib-generate-test-usersig.min.js";

import { sendsmsforVideo, finishvideo } from "../axios/api.js";
import { MessageBox } from 'element-ui'
export default {
  name: "compRoom",
  mixins: [rtc, shareRtc],
  props: {
    type: String,
    sdkAppId: Number,
    secretKey: String,
    userId: String,
    roomId: Number,
    cameraId: String,
    microphoneId: String,
    inviteUserSig: String,
    homeInfo: {
      default: Object
    },
    // 是否结束录制
    endType: {
      type: Boolean,
      default: false
    },
    // 是否开始录制
    begdis: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logList: [],
      inviteLink: "",
      showCopiedTip: false,
      smsUserid: ''
    };
  },
  computed: {
    isHostMode() {
      return this.type !== "invite";
    },
    // isEnLang () {
    //   return this.$i18n.locale === 'en';
    // },
    showInviteLink() {
      return (
        this.isHostMode &&
        (this.isJoined || this.isShareJoined) &&
        this.inviteLink
      );
    }
  },
  watch: {
    cameraId(val) {
      this.switchDevice("video", val);
    },
    microphoneId(val) {
      this.switchDevice("audio", val);
    }
  },
  methods: {
    generateInviteLink() {
      console.log(111);
      if (!this.isHostMode) {
        return;
      }
      const { sdkAppId, secretKey, roomId } = this;
      const inviteUserId = `user_${parseInt(Math.random() * 100000000, 10)}`;
      const userSigGenerator = new LibGenerateTestUserSig(
        sdkAppId,
        secretKey,
        604800
      );
      const inviteUserSig = userSigGenerator.genTestUserSig(inviteUserId);
      console.log(inviteUserSig);
      this.smsUserid = inviteUserId
      this.inviteLink = `${location.origin}/invite?roomId=${roomId}&userId=${inviteUserId}，`;
      // this.inviteLink = `${location.origin}/invite?sdkAppId=${sdkAppId}&userSig=${inviteUserSig}&roomId=${roomId}&userId=${inviteUserId}，`;
      console.log(this.inviteLink);
    },
    // handleCopyInviteLink() {
    //   navigator.clipboard.writeText(this.inviteLink);
    //   this.showCopiedTip = true;
    //   setTimeout(() => {
    //     this.showCopiedTip = false;
    //   }, 1500);
    //   this.generateInviteLink();
    // },
    // 点击【Join Room】按钮
    async handleJoinRoom() {
      if (this.isHostMode) {
        if (!this.sdkAppId || !this.secretKey) {
          alert("Please enter sdkAppId and secretKey");
          return;
        }
        if (!this.userId || !this.roomId) {
          alert("Please enter userId and roomId");
          return;
        }
        this.generateInviteLink();

        const userSigGenerator = new LibGenerateTestUserSig(
          this.sdkAppId,
          this.secretKey,
          604800
        );
        this.userSig = userSigGenerator.genTestUserSig(this.userId);
      } else {
        console.log(this.userId);
        console.log(this.roomId);
        if (!this.userId || !this.roomId) {
          alert("Please reacquire the invitation link");
          return;
        }
        this.userSig = this.inviteUserSig;
      }
      await this.initClient();
      await this.join();
      await this.initLocalStream();
      await this.playLocalStream();
      await this.publish();
    },

    sendmesg() {
      console.log(this.smsUserid, 'this.smsUserid')
      if (!this.smsUserid) {
        this.$message.error('请先进入房间')

      } else if (!this.homeInfo) {
        this.$message.error("请输入被询问人手机号");

      } else {
        const params = {
          // link: this.inviteLink,
          phone: this.homeInfo,
          userId: this.smsUserid,
          roomId: this.roomId
          // type:'other'
        };
        sendsmsforVideo(params).then(res => {
          if (res && res.code === 200) {
            this.$emit("showButton", true);
            MessageBox.confirm(`杭州拱墅疾病预防控制中心】询问笔录已开始，请您点击链接进入房间：https://record.ggws.com.cn/invite?roomId=${this.roomId}&userId=${this.smsUserid}`, '短信内容', {
              confirmButtonText: '确认',
              cancelButtonText: '取消'
            })
            this.$message.success("短信发送成功");
          }
        });
      }

    },

    // 点击【Publish】按钮
    async handlePublish() {
      await this.publish();
    },

    // 点击【Unpublish】按钮
    async handleUnpublish() {
      await this.unPublish();
    },

    // 点击【Leave Room】按钮
    async handleLeave() {
      if (!this.endType && this.begdis) {
        this.$message.error("请先点击结束录制");
        return;
      }
      // await this.leave();
      // console.log();
      const params = {
        roomId: this.roomId
      };
      const res = await finishvideo(params);
      if (res && res.code === 200) {
        // this.leaveRoom();
        // console.log(111);
        this.$message.success("房间解散成功");
        this.smsUserid=null
        this.$emit("showButton", false);
        this.leave();
      }
      // });
    },

    // 显示成功的 Log
    addSuccessLog(log) {
      console.log(log);
      // if (!this.isHostMode) {
      //   return;
      // }
      // this.logList.push({
      //   type: "success",
      //   log
      // });a
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },

    // 显示失败的 Log
    addFailedLog(log) {
      console.log(log);
      // alert("加载失败");
      // if (!this.isHostMode) {
      //   return;
      // }
      // this.logList.push({
      //   type: "failed",
      //   log
      // });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },
    reportSuccessEvent(name) {
      this.$aegis.reportEvent({
        name,
        ext1: `${name}-success`,
        ext2: "webrtcQuickDemoVue2",
        ext3: this.sdkAppId
      });
    },
    reportFailedEvent(name, error, type = "rtc") {
      this.$aegis.reportEvent({
        name,
        ext1: `${name}-failed#${this.roomId}*${type === "share" ? this.shareUserId : this.userId
          }*${error.message}`,
        ext2: "webrtcQuickDemoVue2",
        ext3: this.sdkAppId
      });
    },
    //退出音视频
    leaveRoom(client) {
      client
        .then(() => {
          console.log("退房成功");
          // 停止本地流，关闭本地流内部的音视频播放器
          this.localStream.stop();
          // 关闭本地流，释放摄像头和麦克风访问权限
          this.localStream.close();
          this.localStream = null;
          this.client = null;
          // 退房成功，可再次调用client.join重新进房开启新的通话。
        })
        .catch(error => {
          console.error("退房失败 " + error);
          // 错误不可恢复，需要刷新页面。
        });
    }
  },
  destroyed() {
    //退出音视频
    this.leaveRoom();
  }
};
</script>

<style lang="scss" scoped>
.rtc-container {
  .label {
    margin: 14px 0 6px;
    text-align: left;
    font-weight: bold;
  }

  .control-container {
    text-align: right;
    margin-bottom: 10px;

    div:not(:nth-last-child(1)) {
      margin-bottom: 10px;
    }

    .button:not(:first-child) {
      margin-left: 2px;
    }
  }

  .invite-link-container {
    width: 100%;
    color: #084298;
    background-color: #cfe2ff;
    position: relative;
    padding: 10px 16px;
    margin-bottom: 16px;
    border: 1px solid #b6d4fe;
    border-radius: 0.25rem;

    .invite-input {
      margin-top: 10px;
    }

    .invite-btn {
      display: flex;
      cursor: pointer;
    }
  }

  .info-container {
    width: 100%;
    display: flex;
    margin-top: 20px;
    justify-content: space-between;

    .log-container {
      flex-grow: 1;
      border: 1px solid #dddddd;
      height: 300px;
      padding: 10px;
      margin-right: 16px;
      overflow-y: scroll;

      .log-label {
        margin: 0 0 6px;
        font-weight: bold;
      }

      .log-state {
        display: inline-block;
        margin-right: 6px;
      }

      >div {
        font-size: 12px;
      }
    }

    .local-stream-container {
      width: 50%;
      height: 280px;
      position: relative;
      flex-shrink: 0;

      .local-stream-content {
        width: 100%;
        height: 100%;
      }

      .local-stream-control {
        width: 100%;
        height: 30px;
        position: absolute;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 10px;

        .control {
          margin-left: 10px;
        }

        .icon-class {
          color: #fff;
          cursor: pointer;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .info-container-mobile {
    display: block;

    .log-container {
      margin-right: 0;
    }

    .local-stream-container {
      width: 320px;
      height: 240px;
      margin-top: 10px;
    }
  }

  .remote-container {
    width: 50%;
    display: flex;
    flex-wrap: wrap;

    .remote-stream-container {
      width: 100%;
      height: 280px;
      margin: 0 10px 10px 0;
    }
  }
}
</style>

<i18n>
{
	"en": {
		"Operation": "Operation",
    "Join Room": "Join Room",
    "Publish": "Publish",
    "Unpublish": "Unpublish",
    "Leave Room": "Leave Room",
    "Start Screen Share": "Start Screen Share",
    "Stop Screen Share": "Stop Screen Share",
    "Please enter sdkAppId and secretKey": "Please enter sdkAppId and secretKey",
    "Please enter userId and roomId": "Please enter userId and roomId",
    "Please reacquire the invitation link": "Please reacquire the invitation link!"
	},
	"zh": {
		"Operation": "操作",
    "Join Room": "进入房间",
    "Publish": "发布流",
    "Unpublish": "取消发布流",
    "Leave Room": "离开房间",
    "Start Screen Share": "开始共享屏幕",
    "Stop Screen Share": "停止共享屏幕",
    "Please enter sdkAppId and secretKey": "请输入 sdkAppId 和 secretKey",
    "Please enter userId and roomId": "请输入 userId 和 roomId",
    "Please reacquire the invitation link": "请重新获取邀请链接！"
	}
}
</i18n>
